import { fetchWithToken } from '@utils/api';
import { API_URL } from '@data/constants';
import { Event } from '@services/events';
import { User } from '@services/users';

export enum EventAuditAction {
  CREATE = 'CREATE',
  EDIT = 'EDIT',
  DELETE = 'DELETE',
}

export interface EventAudit {
  id: number;
  event: Event;
  user: User;
  action: EventAuditAction;
  createdAt: string;
}

export async function getEventsAudits({
  limit,
  offset,
  ordering,
}: {
  limit?: number;
  offset?: number;
  ordering?: string;
} = {}): Promise<{ count: number, results: EventAudit[] }> {
  const params = new URLSearchParams();

  if (limit) {
    params.append('limit', String(limit));
  }

  if (offset) {
    params.append('offset', String(offset));
  }

  if (ordering) {
    params.append('ordering', ordering);
  }

  const response = await fetchWithToken(`${API_URL}/api/event-audits?${params.toString()}`);

  if (!response.ok) {
    throw new Error('Error fetching events audits');
  }

  const { data } = await response.json() as { data: { results: EventAudit[], count: number } };

  return data;
}
